import React from 'react'
import PropTypes from 'prop-types'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import IconWeblink from '@assets/images/icons/weblink.svg'

const IconAsLink = ({ width = 15, height = 15, fillColor, linkClass = '', href, icon = IconWeblink, target = '_blank' }) => {
  return (
    <a
      href={href}
      target={target}
      className={linkClass}
      rel="noopener noreferrer">
      <SVGIcon svg={icon} fill={fillColor} height={`${height}px`} width={`${width}px`} />
    </a>
  )
}

IconAsLink.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fillColor: PropTypes.string,
  linkClass: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  target: PropTypes.string,
}

export default IconAsLink
